import React, { ReactNode, CSSProperties } from 'react';
import { Container, Title } from './styles';

export interface IRequestTrainingButtonProps {
  disabled: boolean
  onClick: Function
  text: string
  children?: ReactNode
  style?: CSSProperties
  textColor?: string
}

function RequestTrainingButton({
  disabled, onClick, style, text, children, textColor,
}: IRequestTrainingButtonProps) {
  return (
    <Container
      disabled={disabled}
      isDisabled={disabled}
      onClick={() => onClick()}
      style={style}
    >
      <Title style={{ color: textColor }}>{text}</Title>
      {children}
    </Container>
  );
}

export default RequestTrainingButton;
